import { useMemo } from 'react';
import striptags from 'striptags';
import { diffWords } from 'diff';
import Parser from 'html-react-parser';

export function TextDiffRender({ value = '', targetValue = undefined }) {
    const diffText = useMemo(() => {
        const source = striptags(value);

        if (!targetValue) {
            return source;
        }

        let text = '';
        const diff = diffWords(source, striptags(targetValue));

        diff.forEach((part) => {
            if (part.added) {
                text = text + `<ins>${part.value}</ins>`;
            } else if (part.removed) {
                text = text + `<del>${part.value}</del>`;
            } else {
                text = text + part.value;
            }
        });

        return text;
    }, [value, targetValue]);

    return <>{Parser(`<p>${diffText}</p>`)}</>;
}
